import { orderDisplayNumber } from "../../utils/orderDisplayNumber";
//Redux
import { useDispatch } from "react-redux";
import { setAlert, setComponentActive, setLastComponentActive, setLoading, setOrder } from "../../reducers/userConfigSlice";
//Components
import { OrderDetail } from "./../orderDetail";
import { CiMap } from "react-icons/ci";
import {DirectionsLink} from "../directionsLink";
import { LuClock10 } from "react-icons/lu";
import { FiShoppingBag } from "react-icons/fi";
import { PiPackage, PiPackageThin } from "react-icons/pi";
import { AiOutlineEuro } from "react-icons/ai";
import { Button } from "../button";
import { startDeliveryOrder } from "../../api/orders";
import { translateMessage } from "@delibrandev/utils";
import { parseDate } from "@delibrandev/utils/src/function.js";

export const OrderDetailed = ({ data, refreshOrders }) => {
  const dispatch = useDispatch();

  const handleNavigation = (component, order = null) => {
    order !== null && dispatch(setOrder(order));
    dispatch(setLastComponentActive("orders"));
    dispatch(setComponentActive("" + component));
  };

  const handleOrder = async () => {
    dispatch(setLoading(true));
    try {
      const payload = { orderId: data.orderId };
      const response = await startDeliveryOrder(payload);
      if (response && !response.error) {
        refreshOrders();
        //En este caso el loading false lo setea refreshOrders
        dispatch(setLoading(false));
      } else {
        dispatch(setAlert(translateMessage(response?.message || "Bad request")));
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(setAlert(translateMessage(error?.message || "Bad request")));
      console.error("Error en la petición:", error);
      dispatch(setLoading(false));
    }
  };

  const totalProducts = data.products?.reduce((acc, product) => acc + product.quantity, 0) || 0;
  /*const deliveryTime =
    data?.SalesChannel?.OrderManagerConfigurations && data?.SalesChannel?.OrderManagerConfigurations.length > 0
      ? data?.SalesChannel?.OrderManagerConfigurations[0].deliveryTime
      : 0;*/
  const deliveryTime = Math.floor((Date.now() - new Date(data.updatedAt).getTime()) / 60000);
  return (
    <div className="containerBlock">
      <div className="order-header-page">
        {/*<div className="order-avatar"></div>*/}
        <PiPackageThin size={45} />
        <div className="order-userData">
          <div className="order-userDataName">{data?.Customer?.fullname || ""}</div>
          <div className="order-userDataPhone">
            {data?.Customer?.phone || ""} - {parseDate(data?.Customer?.updatedAt) || ""}
          </div>
        </div>
      </div>
      <OrderDetail text="Hace" value={deliveryTime} icon={<LuClock10 size={"1.1rem"} />} ext={"min"} />
      <OrderDetail text="No. Pedido" value={orderDisplayNumber(data)} icon={<FiShoppingBag size={"1.1rem"} />} />
      <OrderDetail text="No. Productos" value={totalProducts} icon={<PiPackage size={"1.3rem"} />} />
      <OrderDetail
        text="Total del pago"
        value={data.amounts?.total ?? "Pendiente de revisión"}
        label={data.paymentStatus}
        icon={<AiOutlineEuro size={"1.3rem"} />}
        ext={"€"}
        className="order-row-last"
      />
      <div className="order-footer">
        <div className="order-helpers">
          <button type="button" aria-label="Ver dirección y mapa del pedido" onClick={() => handleNavigation("orderResumedMap", data)} style={{background:"none",border:0,padding:0}}><CiMap aria-hidden="true"/></button>
          <Button text={"Detalles"} icon={null} customClass={""} action={() => handleNavigation("orderDetails", data)} />
        </div>
        <div className="order-action">
          <button onClick={handleOrder}>Iniciar entrega</button>
        </div>
      </div>
      <div style={{padding:"5px 13px"}}><DirectionsLink address={data.address}/></div>
    </div>
  );
};
